module.exports = __webpack_public_path__ + "img/investment-dd-l2.90131b31.svg";